

































import { RootState } from '@/store/store';
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { Action, State } from 'vuex-class';
import { ApiAxiosError, ApiState } from '@/store/types/general.types';
import { ToastProgrammatic } from 'buefy';
import { GroupLevelAttribute } from '@/jbi-shared/types/jaas-group-level-attributes.types';

@Component({})
export default class DeleteCourseAttributeModal extends Vue {
  @Prop({ type: Object }) courseAttribute!: GroupLevelAttribute;

  @Action('admin/deleteGroupLevelAttribute')
  deleteCourseAttribute!: (id: number) => void;

  @State((state: RootState) => state.admin.apiState.deleteGroupLevelAttribute)
  deleteCourseAttributeApiState!: ApiState;

  processRemoveCourseAttribute() {
    this.deleteCourseAttribute(+this.courseAttribute.id!);
  }

  closeModal() {
    this.$emit('close');
  }

  triggerPageRefresh() {
    this.$emit('refreshPage');
  }

  @Watch('deleteCourseAttributeApiState', { deep: true })
  deleteCourseAttributeApiStateChanged(state: ApiState) {
    if (state.success) {
      ToastProgrammatic.open({
        queue: true,
        type: 'is-dark',
        position: 'is-top',
        message: `Course attribute successfully deleted.`
      });

      this.closeModal();
      this.triggerPageRefresh();
    }

    if (state.error) {
      ToastProgrammatic.open({
        queue: true,
        type: 'is-danger',
        position: 'is-top',
        message: String(
          (state.error as ApiAxiosError)?.response?.data?.message || state.error
        ),
        duration: 5000
      });
    }
  }
}
